import { Injectable } from '@angular/core';
import { SelectOption } from './form.model';
import { qualityType } from './quality.model';

const TRANSLATION_KEY_PREFIX = 'quality.';

@Injectable()
export class QualityOptionsBuilder {
  private qualities?: SelectOption[];

  getQualities(): SelectOption[] {
    if (!this.qualities) {
      this.qualities = Object.values(qualityType).map((type) => ({
        value: type,
        display: TRANSLATION_KEY_PREFIX + type,
      }));
    }
    return this.qualities;
  }
}
